module.exports = __webpack_public_path__ + "img/25_73.a1d8abff.png";